/**
 * API Endpoints — Centralized constants matching FastAPI Backend routes
 */
export const API_ENDPOINTS = {
  HEALTH: '/health',

  AUTH: {
    LOGIN:           '/auth/login',
    LOGOUT:          '/auth/logout',
    REGISTER:        '/auth/register',
    REFRESH:         '/auth/refresh',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD:  '/auth/reset-password',
    ME:              '/auth/me',
  },

  PUBLIC: {
    COUNTRIES:            '/public/countries',
    UNIVERSITIES:         '/public/universities',
    PROGRAMS:             '/public/programs',
    CONTACT:              '/public/contact',
    REGISTER_CONSULTANCY: '/public/register/consultancy',
    REGISTER_STUDENT:     '/public/register/student',
  },

  SUPERADMIN: {
    DASHBOARD: '/superadmin/dashboard',

    // Consultancies
    CONSULTANCIES:                      '/superadmin/consultancies',
    CONSULTANCIES_EXPORT:               '/superadmin/consultancies/export/all',
    CONSULTANCY:          (id: string) => `/superadmin/consultancies/${id}`,
    UPDATE_CONSULTANCY_STATUS: (id: string) => `/superadmin/consultancies/${id}/status`,
    CONSULTANCY_SUBSCRIPTION:  (id: string) => `/superadmin/consultancies/${id}/subscription`,
    CONSULTANCY_SETTINGS:      (id: string) => `/superadmin/consultancies/${id}/settings`,
    CONSULTANCY_STATS:         (id: string) => `/superadmin/consultancies/${id}/stats`,
    CONSULTANCY_EMPLOYEES:     (id: string) => `/superadmin/consultancies/${id}/employees`,
    CONSULTANCY_ACTIVITY:      (id: string) => `/superadmin/consultancies/${id}/activity`,

    // Subscriptions
    SUBSCRIPTIONS:        '/superadmin/subscriptions',
    SUBSCRIPTION:         (id: string) => `/superadmin/subscriptions/${id}`,

    // Countries
    COUNTRIES:            '/superadmin/countries',
    COUNTRY:              (id: string) => `/superadmin/countries/${id}`,

    // Universities
    UNIVERSITIES:         '/superadmin/universities',
    UNIVERSITY:           (id: string) => `/superadmin/universities/${id}`,

    // Institutions
    INSTITUTIONS:         '/superadmin/institutions',
    INSTITUTION:          (id: string) => `/superadmin/institutions/${id}`,

    // Programs
    PROGRAMS:             '/superadmin/programs',
    PROGRAM:              (id: string) => `/superadmin/programs/${id}`,

    // Sessions
    SESSIONS:             '/superadmin/sessions',
    SESSION:              (id: string) => `/superadmin/sessions/${id}`,

    // Intakes
    INTAKES:              '/superadmin/intakes',
    INTAKE:               (id: string) => `/superadmin/intakes/${id}`,

    // Service Providers
    SERVICE_PROVIDERS:    '/superadmin/service-providers',
    SERVICE_PROVIDER:     (id: string) => `/superadmin/service-providers/${id}`,

    // Audit
    AUDIT_LOGS:           '/superadmin/audit-logs',
    REVIEWS_AGGREGATED:   '/superadmin/reviews/aggregated',
  },

  // Outgoing email (SMTP) — platform-wide for the super admin, per consultancy for tenants
  EMAIL: {
    PLATFORM: {
      SETTINGS: '/superadmin/email/settings',
      TEST:     '/superadmin/email/test',
      LOGS:     '/superadmin/email/logs',
    },
    TENANT: {
      SETTINGS: '/tenants/email/settings',
      TEST:     '/tenants/email/test',
      LOGS:     '/tenants/email/logs',
    },
  },

  USERS: {
    LIST:   '/users',
    DETAIL: (id: string) => `/users/${id}`,
    CREATE: '/users',
    UPDATE: (id: string) => `/users/${id}`,
    DELETE: (id: string) => `/users/${id}`,
  },

  TENANTS: {
    DASHBOARD:  '/tenants/dashboard',
    PROFILE:    '/tenants/profile',
    SETTINGS:   '/tenants/settings',
    CURRENCIES: '/tenants/currencies',
    CURRENCY:   (id: string) => `/tenants/currencies/${id}`,
    AGENTS:     '/tenants/agents',
    AGENT:      (id: string) => `/tenants/agents/${id}`,
    REVIEWS:    '/tenants/reviews',
  },

  AGENT_PORTAL: {
    DASHBOARD:              '/agent/dashboard',
    ME:                     '/agent/me',
    STUDENTS:               '/agent/students',
    STUDENT:                (id: string) => `/agent/students/${id}`,
    STUDENT_DOCUMENTS:      (id: string) => `/agent/students/${id}/documents`,
    UPDATE_STUDENT:         (id: string) => `/agent/students/${id}`,
    DELETE_STUDENT:         (id: string) => `/agent/students/${id}`,
    APPLICATIONS:           '/agent/applications',
    APPLICATION:            (id: string) => `/agent/applications/${id}`,
    CREATE_STUDENT:         '/agent/students',
    CREATE_APPLICATION:     '/agent/applications',
    UPDATE_APPLICATION:     (id: string) => `/agent/applications/${id}`,
    DELETE_APPLICATION:     (id: string) => `/agent/applications/${id}`,
    LEADS:                  '/agent/leads',
    LEAD:                   (id: string) => `/agent/leads/${id}`,
    SHORTLISTED_UNIVERSITIES: '/agent/shortlisted-universities',
    CATALOG_COUNTRIES:      '/agent/catalog/countries',
    CATALOG_UNIVERSITIES:   '/agent/catalog/universities',
    CATALOG_PROGRAMS:       '/agent/catalog/programs',
    CATALOG_SESSIONS:       '/agent/catalog/sessions',
    CATALOG_INTAKES:        '/agent/catalog/intakes',
    COUNSELORS:             '/agent/counselors',
    REVIEWS:                '/agent/reviews',
  },
} as const;
